import { useAtomValue } from 'jotai';
import { useCallback } from 'react';

import { EPrescribeMedicationsConnected } from '@grow-therapy-team/seedling-components';

import { selectedClientInfoAtom, selectedClientUserShortIdAtom } from '../state';
import { useGetCurrentProviderQuery } from '../useGetCurrentProviderQuery';
import { useCachedPatientByShortId } from '../useGetPatientByShortId';
import { PRESCRIBER_EPRESCRIBE_STATUS, usePrescriberEprescribeStatus } from './usePrescriberEprescribeStatus';
import { getClientChartMedicationsLink } from './utils';

export function EPrescribeMedicationsCardWrapper() {
  const clientUserShortId = useAtomValue(selectedClientUserShortIdAtom) ?? '';
  const patientShortId = useAtomValue(selectedClientInfoAtom)?.patientShortId;
  const { data: cachedPatientData } = useCachedPatientByShortId(patientShortId);
  const patient = cachedPatientData?.patientChart;

  const { data: providerData } = useGetCurrentProviderQuery();
  const isPrescriber = Boolean(providerData?.currentProvider?.isPrescriber);
  const { status } = usePrescriberEprescribeStatus(isPrescriber);
  const shouldLoadMedications = status === PRESCRIBER_EPRESCRIBE_STATUS.IDP_COMPLETED;

  const patientId = patient?.id;
  const handleOpenMedicationsPage = useCallback(() => {
    if (!patientId) return;
    window.open(getClientChartMedicationsLink(patientId), '_blank', 'noopener,noreferrer');
  }, [patientId]);

  if (!clientUserShortId) return null;

  return (
    <EPrescribeMedicationsConnected
      clientUserShortId={clientUserShortId}
      isBoxed
      isInverse
      onOpenMedicationsPage={handleOpenMedicationsPage}
      openNewWindow
      patientFirstName={patient?.firstName ?? ''}
      shouldLoadMedications={shouldLoadMedications}
    />
  );
}
